// Always proxied, unlike fetchQueryPath: useLazyFetch derives its payload key
// from the URL, so branching on the environment would give the server and the
// client different keys and force a refetch after hydration. On the server the
// `/api` call is resolved in-process by Nitro rather than over the network.
export const lazyFetchQueryPath = (path: string) => {
  return useLazyFetch('/api/strapi-rest', { query: { path } })
}
